import React from "react";

import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import PropTypes from "prop-types";

import RbTrapFocus from "components/RbTrapFocus";

function RbPopper(props) {
  const { autoFocus, onClose, open, children, ...other } = props;

  const targetRef = React.useRef(null);

  const handleClickAway = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape" && onClose) {
      event.stopPropagation();
      onClose();
      if (targetRef.current) {
        targetRef.current.focus();
      }
    }
  };

  React.useEffect(() => {
    if (open) {
      targetRef.current = document.activeElement;
    }
  }, [open, onClose]);

  return (
    <Popper {...other} open={open} role="dialog" onKeyDown={handleKeyDown}>
      <ClickAwayListener onClickAway={handleClickAway}>
        <RbTrapFocus autoFocus={autoFocus}>{children}</RbTrapFocus>
      </ClickAwayListener>
    </Popper>
  );
}

RbPopper.propTypes = {
  autoFocus: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

RbPopper.defaultProps = {
  autoFocus: undefined,
  open: undefined,
  onClose: undefined,
  children: null,
};

export default React.memo(RbPopper);
